<template>
  <div>
    <v-row justify="center">
      <v-col cols="10">
        <KpiListComponent :items="kpis">

          <template v-slot:exampleSlot1="{index, closeDropdown}">
            <KpiDropdownComponent
              @action1="onAction(1, index)"
              @action2="onAction(2, index)"
              @action3="onAction(3, index)"
              :closeDropdown="closeDropdown"
            />
          </template>

          <template v-slot:exampleSlot2="{dropdownData}">
            <div style="width: 200px">
              {{ dropdownData }}
            </div>
          </template>

        </KpiListComponent>
      </v-col>
    </v-row>
    <v-row justify="center">
      <v-col cols="auto">
        <TopListComponent v-bind="topListData[0]">
          <template v-slot:default="{closeDropdown}">
            <KpiDropdownComponent :closeDropdown="closeDropdown"/>
          </template>
        </TopListComponent>
        <TopListComponent v-bind="topListData[1]">
          <template v-slot:default="{closeDropdown}">
            <KpiDropdownComponent :closeDropdown="closeDropdown"/>
          </template>
        </TopListComponent>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import KpiListComponent from "@/components/lead/Dashboard/KpiListComponent";
import {colors, trendDirections} from "@/components/lead/kpi/KpiSingleComponent";
import {
  colors as topListColors,
  trendDirections as topListTrendDirections
} from "@/components/lead/Dashboard/TopListComponent";
import KpiDropdownComponent from "@/components/lead/kpi/examples/KpiDropdownComponent";
import TopListComponent from "@/components/lead/Dashboard/TopListComponent";

export default {
  name: "TopListView",
  components: {TopListComponent, KpiDropdownComponent, KpiListComponent},

  setup() {
    const kpis = [
      {
        title: 'Neue Leads',
        kpi: 13,
        interval: 'Aktueller Monat',
        showDropdownMenu: true,
        dropdownSlot: 'exampleSlot1'
      },
      {
        title: '# Gewonnene Leads',
        kpi: 45,
        interval: 'Letzter Monat',
        trend: '76,4 %',
        trendDirection: trendDirections.UP,
        showDropdownMenu: true,
        dropdownSlot: 'exampleSlot1'
      },
      {
        title: '# Verlorene Leads',
        kpi: 23,
        kpiColor: colors.GRAY,
        interval: 'Letzter Monat',
        trend: '1,4 %',
        trendDirection: trendDirections.DOWN,
        showDropdownMenu: true,
        dropdownSlot: 'exampleSlot1'
      },
      {
        title: 'Conversion Rate',
        kpi: '8,2%',
        interval: 'Letzter Monat',
        trend: '1,4 %',
        trendDirection: trendDirections.DOWN,
        showDropdownMenu: true,
        dropdownSlot: 'exampleSlot2',
        dropdownData: {data: 'example Data'}
      },
      {
        title: 'Ø Sales Cycle',
        kpi: '8W2T',
        interval: 'Letzter Monat',
        trend: '0,0 %',
        trendDirection: trendDirections.FLAT,
        showDropdownMenu: true,
        dropdownSlot: 'exampleSlot2',
        dropdownData: {data: 'example Data 2'}
      },
      {
        title: 'Ø Zeit bis zur Verteilung',
        kpi: '2S35M',
        interval: 'Aktueller Monat',
        trend: '1,4 %',
        trendDirection: trendDirections.DOWN,
        showDropdownMenu: true,
        dropdownSlot: 'exampleSlot2',
        dropdownData: {data: 'example Data 3'}
      }
    ]

    const topListData = [
      {
        titleCategory: 'TOP3',
        title: 'Leadgeber: Lead-to-Sale',
        interval: 'Letzte Woche',
        category: 'Conversion rate',
        list: [
          {
            text: 'Cleber GmbH',
            trendText: '12,4 %',
            trendDirection: topListTrendDirections.UP,
            trendIconColor: topListColors.RED
          },
          {
            text: 'Duracell AG',
            trendText: '11,7 %',
            trendDirection: topListTrendDirections.DOWN,
          },
          {
            text: 'Dunlop',
            trendText: '8,9 %',
            trendDirection: topListTrendDirections.UP
          }
        ]
      },
      {
        titleCategory: 'TOP3',
        title: 'Leadnehmer: Schnellste Bearbeitung',
        interval: 'Letzte Woche',
        category: 'Ø Sales Cycle',
        list: [
          {
            text: 'Duracell AG',
            trendText: '3W4T',
            trendDirection: topListTrendDirections.DOWN
          },
          {
            text: 'Cleber GmbH',
            trendText: '6W0T',
            trendDirection: topListTrendDirections.UP,
          },
          {
            text: 'Dunlop',
            trendText: '6W2T',
            trendDirection: topListTrendDirections.DOWN
          }
        ]
      }
    ]


    function onAction(actionNumber, kpiArrayIndex) {
      console.log(`Actiion ${actionNumber} on `, kpis[kpiArrayIndex])
    }

    return {kpis, onAction, topListData}
  }
}
</script>

<style scoped>

</style>
